/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ServiceProviderCategoryEnum = 1 | 2;

export const ServiceProviderCategoryEnum = {
    NUMBER_1: 1 as ServiceProviderCategoryEnum,
    NUMBER_2: 2 as ServiceProviderCategoryEnum
};